import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  FindOffersQueryQuery,
} from "../../../schemaTypes";

export const findOffersQuery = gql`
  query FindOffersQuery {
    findOffers {
      id
      title
      description
      bannerUrl
      category {
        id
        name
        imgSrc
        createdBy{
          id
          role
        }
        createdAt
        updatedAt
      }
      offerType
      discountType
      discountValue
      partnerVoucher
      referralUrl
      status
      usageLimitPerUser
      totalUsageLimit
      startDate
      endDate
      community{
        id
        name
        alias
      }
      location{
        id
        city
        district
        streetName
        country
        postalCode
        landmark
        latitude
        longitude
        createdAt
      }
      redemptions
      revenueGenerated
      clickThroughs
      featured
      createdBy{
        id
        role
        admin {
          id
          shortId
          firstname
          lastname
          email
          phone
          merchantProfile {
            id
            businessName
            businessType
            regCountry
            businessRegNumber
            taxId
            address
            addressAlt
            city
            country
            postcode
            companyName
            username
            industry {
              id
              name
              createdBy{
                id
                role
              }
              createdAt
              updatedAt
            }
            companyLocation
            logoUrl
            bannerUrl
            description
            commissionRate
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      # njoyCode {
      #   id
      #   code
      #   redeemedAt
      #   createdAt
      #   updatedAt
      # }
      offerTOR
      createdAt
      updatedAt
    }
  }
`;

export const newOfferSubscription = gql`
  subscription NewOfferSubscription {
    newOffer {
      id
      title
      description
      bannerUrl
      category {
        id
        name
        imgSrc
        createdBy{
          id
          role
        }
        createdAt
        updatedAt
      }
      offerType
      discountType
      discountValue
      partnerVoucher
      referralUrl
      status
      usageLimitPerUser
      totalUsageLimit
      startDate
      endDate
      community{
        id
        name
        alias
      }
      location{
        id
        city
        district
        streetName
        country
        postalCode
        landmark
        latitude
        longitude
        createdAt
      }
      redemptions
      revenueGenerated
      clickThroughs
      featured
      createdBy{
        id
        role
        admin {
          id
          shortId
          firstname
          lastname
          email
          phone
          merchantProfile {
            id
            businessName
            businessType
            regCountry
            businessRegNumber
            taxId
            address
            addressAlt
            city
            country
            postcode
            companyName
            username
            industry {
              id
              name
              createdBy{
                id
                role
              }
              createdAt
              updatedAt
            }
            companyLocation
            logoUrl
            bannerUrl
            description
            commissionRate
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      # njoyCode {
      #   id
      #   code
      #   redeemedAt
      #   createdAt
      #   updatedAt
      # }
      createdAt
      updatedAt
    }
  }
`;

export function useFindOffers() {
  const { data, loading, subscribeToMore } = useQuery<FindOffersQueryQuery>(findOffersQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newOfferSubscription,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findOffers: [
            ...prev.findOffers,
            (subscriptionData.data as any).newOffer
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    offers: data?.findOffers ?? [],
    loading
  };
}